export function LeaveTabHeader() {
  return (
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 min-w-0">
      <div className="min-w-0">
        <h1 className="text-2xl font-bold text-slate-900">Staff Leave</h1>
        <p className="text-sm text-slate-500 mt-1">
          Manage employee leave balances and leave requests.
        </p>
      </div>
    </div>
  )
}
